import React, { Fragment } from "react";
import {
  Grid,
  Icon,
  Typography,
  CardContent,
  Card,
  CardHeader,
} from "@material-ui/core";

import ModalTravelInformation from "../../ResultsPage/partials/ModalTravelInformation";

import moment from "moment";
import "moment/locale/es";
import "moment-timezone";

import IconC from "./../../../components/_IconC";

export default function ProductDetail(props) {
  const productDetail = props.productDetail;

  const searchInfo = props.bookingItems;

  const evalSeatReservationRepeated = (segmento) => {
    const seatReservations = [];
    for (var i = 0; i < segmento.length; i++) {
      seatReservations.push(segmento[i].seatReservationConditions);
    }
    return seatReservations.every((val, i, arr) => val === arr[0]);
  };

  const GetItemsSegment = (props) => {
    const {
      seg,
      idSeg,
      item,
      comfortCategoryCode,
      cabinClassCode,
      ticketingOptions,
    } = props;

    return (
      <Fragment>
        <Grid container spacing={1} className="mb-05">
          <Grid item xs={6}>
            <Typography className="label-resume">SALIDA:</Typography>
            <Typography className="detail-item">
              <span>
                <Icon className="icon">place</Icon> {seg.origin.localLabel}
              </span>
              <br />
              <span style={{ textTransform: "capitalize" }}>
                <Icon className="icon">event</Icon>{" "}
                {moment(seg.departure).locale("es").format("dddd, DD MMM YY")}
              </span>
            </Typography>
            <Typography className="detail-item hora">
              <Icon className="icon">schedule</Icon>{" "}
              <span>{moment(seg.departure).locale("es").format("HH:mm")}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className="label-resume">LLEGADA:</Typography>
            <Typography className="detail-item">
              <span>
                <Icon className="icon">place</Icon> {seg.destination.localLabel}
              </span>
              <br />
              <span style={{ textTransform: "capitalize" }}>
                <Icon className="icon">event</Icon>{" "}
                {moment(seg.arrival).locale("es").format("dddd, DD MMM YY")}
              </span>
            </Typography>
            <Typography className="detail-item hora">
              <Icon className="icon">schedule</Icon>{" "}
              <span>{moment(seg.arrival).locale("es").format("HH:mm")}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1} className="mb-05">
          <Grid item xs={6}>
            <Typography className="label-resume">DURACIÓN:</Typography>
            <Typography className="detail-item">
              <span>
                <Icon className="icon">schedule</Icon> {seg.duration}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className="label-resume">TREN:</Typography>
            <Typography className="detail-item">
              <span>
                <Icon className="icon">train</Icon> {seg.vehicle.code}. N°:{" "}
                {seg.vehicle.reference}
              </span>
            </Typography>
          </Grid>
        </Grid>
        <Typography className="label-resume">TARIFA:</Typography>
        <Typography className="detail-item">
          <span>
            <Icon className="icon">train</Icon> {comfortCategoryCode}
          </span>{" "}
          <span>{cabinClassCode}</span>
        </Typography>
        <ul className="list-unstyled list-elements">
          <li>
            <Typography>
              <IconC icon="seat" alt="seat" className="custom_icon icon" />
              {seg.marketingCarrier === "DBAHN" ? (
                <span style={{ color: "red", important: true }}>
                  COSTO POR RESERVA DE ASIENTO NO INCLUIDO. EL MISMO SE
                  ADICIONARA AUTOMÁTICAMENTE AL FINALIZAR LA EMISIÓN, EN CASO DE
                  SER OBLIGATORIO (APROX. USD 6 POR PASAJERO POR TRAMO)
                </span>
              ) : (
                <span>{seg.seatReservationConditions}</span>
              )}
            </Typography>
          </li>
          <li>
            <Typography>
              <Icon className="icon">info</Icon>
              {ticketingOptions[0]}
            </Typography>
          </li>
          { seg.marketingCarrier === "DBAHN" && 
              <li>
              <Typography>
                <Icon className="icon">
                  info
                </Icon>
                <span>
                  Tarifa Sparpreis: Si el ticket no es utilizado, se permite reembolso hasta 1 día antes de la fecha de salida del tren con una penalidad de Euros 10, el mismo se realizará por medio de un voucher para utilizar en futuros viajes en DB y deberá ser validado directamente en <a href="https://www.bahn.com/es/">https://www.bahn.com/es/</a>
                </span>
              </Typography>
              </li>
            }
        </ul>
        <br></br>
      </Fragment>
    );
  };

  const GetItemsLeg = (props) => {
    const { item } = props;
    /* CHECKOUT */
    if (item.leg && item.leg.segments) {
      return (
        <Fragment>
          {item.leg.segments.map((seg, idSeg) => (
            <Fragment key={idSeg}>
              {item.leg.segments.length > 0 && (
                <Typography className="segment-title">
                  Segmento {idSeg + 1}
                </Typography>
              )}
              <GetItemsSegment
                ticketingOptions={item.ticketingOptions}
                seg={seg}
                idSeg={idSeg}
                item={item}
                cabinClassCode={item.products[idSeg]?.cabinClass.code}
                comfortCategoryCode={item.comfortCategory.code}
              />
            </Fragment>
          ))}
        </Fragment>
      );
    }
    /* END CHECKOUT */

    /* VISTA FINAL */
    if (item.legs && item.legs[0].segments) {
      return (
        <Fragment>
          {item.legs[0].segments.map((seg, idSeg) => (
            <Fragment key={idSeg}>
              {item.legs[0].segments.length > 0 && (
                <Typography className="segment-title">
                  Segmento {idSeg + 1}
                </Typography>
              )}
              <GetItemsSegment
                ticketingOptions={item.ticketingOptions}
                seg={seg}
                idSeg={idSeg}
                item={item}
                cabinClassCode={item.products[idSeg]?.cabinClass.code}
                comfortCategoryCode={item.legs[0].comfortCategory.code}
              />
            </Fragment>
          ))}
        </Fragment>
      );
    }
    /* END VISTA FINAL */
  };
  /*  const GetProductCondition = (props) =>   {
        const item = props
        return
            ( <div>
                <Button className="ver-tarifa"  onClick={handleClickOpen} color="secondary">Condiciones de la Tarifa</Button>

                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Condiciones de la tarifa
                      </DialogTitle>

                      <DialogContent dividers>
                        {item.products.map((data, y) =>
                            <Typography className="small">{data.paxType.label}-<RawMarkup content={data.conditions} /></Typography>
                        )}
                     </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                      Cerrar
                    </Button>
                  </DialogActions>
                </Dialog>
              </div> )

    } */
  return (
    <Card className="product-detail card">
      <CardHeader
        className="product-detail-header head-resume"
        avatar={<Icon>{productDetail?.icon}</Icon>}
        title={productDetail?.title}
      />
      <CardContent>
        {searchInfo &&
          searchInfo.map((item, idItem) => (
            <div key={idItem}>
              <Typography
                className="tramo-title"
                variant="body1"
                component="h4"
              >
                Tramo {idItem + 1}
              </Typography>

              <GetItemsLeg item={item} />

              <ModalTravelInformation
                type="condiciones"
                detailConditions={item.products}
                ticketingOptions={item.ticketingOptions}
                segmento={null}
                ages={props.ages}
                page={props.page}
                trainService={(item.leg) ? item?.leg?.segments[0]?.marketingCarrier : item?.legs[idItem]?.segments[0]?.marketingCarrier}
              />
            </div>
          ))}
      </CardContent>
    </Card>
  );
}
